// src/redux/feature/projectRequest/projectRequestApi.ts

import { baseApi } from "@/redux/api/baseApi";

export type TAvailabilityTimeSlot = {
  id: string;
  start: string;
  end: string;
};

export type TAvailabilityDay = {
  date: string;
  timeSlot: TAvailabilityTimeSlot;
};

export type TProjectRequestStatus =
  | "pending"
  | "accepted"
  | "rejected"
  | "expired"
  | "converted"
  | "cancelled";

export type TProjectRequestDetailsResponse = {
  success?: boolean;
  message?: string;
  data: {
    projectRequest: {
      _id: string;
      status: TProjectRequestStatus;
      expiresAt: string; // ISO
      remainingSeconds: number;
      selected_slot: TAvailabilityDay;
      order_id: string;
      video_ids: string[];
      creatorId: string;
      clientId: string;
    };
    order: any; // you can type this later (TOrderDetails)
  };
};

export type TAcceptProjectRequestBody = {
  wardrobe_image?: string;
  background_image?: string;
  send_product_notification?: boolean;
};

export type TRejectProjectRequestBody = {
  reason?: string;
};

export const projectRequestApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getProjectRequestDetails: builder.query<
      TProjectRequestDetailsResponse,
      { projectRequestId: string }
    >({
      query: ({ projectRequestId }) => ({
        url: `/project-requests/get-project-details/${projectRequestId}`,
        method: "GET",
      }),
      providesTags: (_res, _err, arg) => [
        { type: "ProjectRequest", id: arg.projectRequestId },
      ],
    }),

    acceptProjectRequest: builder.mutation<
      any,
      { projectRequestId: string; body?: TAcceptProjectRequestBody }
    >({
      query: ({ projectRequestId, body }) => ({
        url: `/project-requests/${projectRequestId}/accept`,
        method: "POST",
        body: body ?? {},
      }),
      invalidatesTags: (_res, _err, arg) => [
        { type: "ProjectRequest", id: arg.projectRequestId },
      ],
    }),

    rejectProjectRequest: builder.mutation<
      any,
      { projectRequestId: string; body?: TRejectProjectRequestBody }
    >({
      query: ({ projectRequestId, body }) => ({
        url: `/project-requests/${projectRequestId}/reject`,
        method: "POST",
        body: body ?? {},
      }),
      invalidatesTags: (_res, _err, arg) => [
        { type: "ProjectRequest", id: arg.projectRequestId },
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetProjectRequestDetailsQuery,
  useLazyGetProjectRequestDetailsQuery,
  useAcceptProjectRequestMutation,
  useRejectProjectRequestMutation,
} = projectRequestApi;
